<div class="d-flex gap-1">
  <app-icon-button [size]="'small'" [buttonIcon]="'profile'" [type]="'floating'"
    (clicked)="directToConsultaantProfile()"></app-icon-button>
     <app-icon-button [size]="'small'" [buttonIcon]="'suitcase'" [type]="'floating'"
    (clicked)="directToStakeholderList()"></app-icon-button>
  <app-icon-button [size]="'small'" [buttonIcon]="'task'" [type]="'floating'"
    (clicked)="directToTask()"></app-icon-button>
</div>